import React, { useState } from 'react';

import Button from 'components/Button';
import { FiEdit3 } from 'react-icons/fi';

interface EditableFieldProps {
  label: string;
  value: string;
  children?: React.ReactNode;
}

export default function EditableField({
  label,
  value,
  children,
}: EditableFieldProps) {
  const [editable, setEditable] = useState(false);
  return (
    <section>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: 8,
        }}
      >
        <h5>{label}</h5>
        <div style={{ display: 'flex', gap: 4 }}>
          <Button
            type="button"
            onClick={() => {
              console.log('teste');
              setEditable(prevState => !prevState);
            }}
            fill
            color="font"
            round
          >
            <FiEdit3 />
          </Button>
        </div>
      </div>
      {editable && children ? children : <p>{value || '-'}</p>}
    </section>
  );
}
